/* eslint-disable prettier/prettier */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import makeRequest from 'src/services/api'
import { ssoLoginUrl, ssoResponseUrl, ssoLogoutUrl } from 'src/services/urls'
import { showToast } from './toastSlice'
import { setAuthToken, setCountryCode } from 'src/services/api'
import History from 'src/@history'
const initialState = {
  loading: false,
  countryCode: sessionStorage.getItem('superAdminCountryCode') || '',
  selectCountryDialog: false,
  data: { emailId: 'dummy@email.com' },
  error: '',
}

export const ssoLogin = createAsyncThunk(
  'bootstrap/ssoLogin',
  async (body, { dispatch, getState }) => {
    try {
      const response = await makeRequest(ssoLoginUrl(), 'POST', body)
      if (response.status === 200) {
        sessionStorage.setItem('syngentaAdminToken', response.data.data.sso.idToken)
        sessionStorage.setItem('syngentaBearerToken', response.data.data.token)
        sessionStorage.setItem('syngentaCountryCode', response.data.data.countryCode)

        setAuthToken()
        setCountryCode()
        return response.data.data
      } else {
        sessionStorage.clear()
        History.replace('/#/login')
        return {}
      }
    } catch (e) {
      if (e?.response?.data?.error?.message.includes('Unable to login'))
        dispatch(
          showToast({
            title: 'Application access error',
            message: 'You do not have permission to access this application.',
            color: 'danger',
          }),
        )

      History.replace('/#/login')
      sessionStorage.clear()
    }
  },
)

export const ssoResponse = createAsyncThunk('bootstrap/ssoResponse', async (body, { dispatch }) => {
  try {
    dispatch(setLoading())

    const response = await makeRequest(ssoResponseUrl(), 'POST', body.body)

    if (response.status === 200) {
      body.pca.setActiveAccount(body.body.account)
      sessionStorage.setItem('syngentaAdminToken', response.data.data.sso.idToken)
      dispatch(ssoLogin({ idToken: response.data.data.sso.idToken }))
    }
    if (response.data.statusCode === 500) {
      dispatch(
        showToast({
          title: `${response?.data?.statusMessage}`,
          message: 'User does not exist',
          color: 'danger',
        }),
      )
      History.replace('/#/login')
    }
    // window.location.reload()

    return {}
  } catch (e) {
    if (e?.response?.data?.statusCode === 500)
      dispatch(
        showToast({
          title: 'Application access error',
          message: 'You do not have permission to access this application.',
          color: 'danger',
        }),
      )
    History.replace('/#/login')
    sessionStorage.clear()
  }
})

export const ssoLogout = createAsyncThunk('bootstrap/ssoLogout', async () => {
  try {
    sessionStorage.clear()
    const response = await makeRequest(ssoLogoutUrl(), 'GET')
    if (response.status === 200) {
      sessionStorage.clear()
      History.replace('/#/login')
      return response.data.data
    }
    History.replace('/#/login')
    window.location.reload()
  } catch (e) {
    // console.log('err logging out---', e)
  }
})

const bootstrapSlice = createSlice({
  name: 'bootstrap',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true
    },
    setSelectCountryDialog: (state, action) => {
      state.selectCountryDialog = action.payload
    },
    setCountryCodeSlice: (state, action) => {
      state.countryCode = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ssoLogin.pending, (state) => {
      state.loading = true
    })
    builder.addCase(ssoLogin.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
      state.error = ''
      state.setCountryCode = true
    })
    builder.addCase(ssoLogin.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.error = action.error.message
    })
    builder.addCase(ssoResponse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(ssoResponse.fulfilled, (state, action) => {
      state.loading = false
      state.error = ''
    })
    builder.addCase(ssoResponse.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.error = action.error.message
    })
    builder.addCase(ssoLogout.pending, (state) => {
      state.loading = true
    })
    builder.addCase(ssoLogout.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
      state.error = ''
    })
    builder.addCase(ssoLogout.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.error = action.error.message
    })
  },
})

export default bootstrapSlice.reducer
export const { setLoading, setSelectCountryDialog, setCountryCodeSlice } = bootstrapSlice.actions
